<template>
  <div class="meetingroom">
    <!-- :setready="s"
      :setmyjob="myjobs"
      :setpacking="packing"
      :orders="newjobs" -->
     
    <navbarStaff />
    <div class="space"></div>
    <!-- <h1>{{ time_count }}</h1> -->
    <div class="space_avatar"></div>
    <div class="container">
      <br />
      <div class="circle_content">
        <div class="circle_floting">
          <div class="circle">
            <span class="circle__btn">
              <img
                class="circle_img"
                :src="require('@/assets/avatars/' + code + '.jpg')"
                alt=""
              />
              <!-- <ion-icon class="pause" name="pause"></ion-icon>
            <ion-icon class="play" name="play"></ion-icon> -->
            </span>
            <span class="circle__back-1"></span>
            <span class="circle__back-2"></span>
          </div>
        </div>
      </div>
      <div class="calendar-list">
        <div class="card card-order-list card-margin calendar-border">
          <div class="card-body">
            <div class="container">
              <div class="card-content-more">
                <h1 class="btn-floating">
                  {{ choosedDay2.dateFormat | moment }}
                  <!-- {{ date | moment }} -->
                </h1>
              </div>
              <!-- :minDate="dateTime" -->
              <vue-horizontal-calendar
                choosedDate:dateTime
                v-on:change="dateChange2"
                lang="en"
                choosedItemColor="#ff5f2d"
                todayItemColor="#bec8e4"
                class="shadow-date"
              >
                <img
                  slot="leftIcon"
                  src="../../assets/icons/right.png"
                  style="width: 20px; margin-top: -2px"
                />
                <img
                  slot="rightIcon"
                  src="../../assets/icons/left.png"
                  style="width: 20px; margin-top: -2px"
                />
              </vue-horizontal-calendar>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <!-- ============================================ Card  background Start ==================================== -->
      <!-- <div class="card card-order-list card-margin calendar-border"> -->
      <!-- ============================================ ยืม คืน =================================== -->
      <!-- <div class="card-body"> -->
      <div class="row">
        <div class="col">
          <div class="search">
            <input
              type="text"
              class="search__input"
              placeholder="Return"
              v-model="text"
              style="border-radius: 30px"
              v-on:keyup.enter="checkSTD"
              autofocus
            />
            <div class="search__icon">
              <i class="fa-solid fa-barcode"></i>
              <!-- <ion-icon name="search"></ion-icon> -->
            </div>
          </div>

          <!-- <br /> -->
          <!-- Actual search box -->
        </div>
      </div>
      <!-- </div>
    </div> -->
      <!-- ============================================ End Card  background Start ==================================== -->
      <!-- ============================================ Tabs Menu =============================== -->
      <br />
      <br />
      <div class="tebs_content">
        <div class="tebs_floting">
          <div class="segmented-control">
            <input
              type="radio"
              name="radio2"
              v-model="radio_btn"
              @change="onChange"
              value=""
              id="tab-1"
              checked
            />
            <label for="tab-1" class="segmented-control__1"> <p>Room</p></label>

            <input
              type="radio"
              name="radio2"
              v-model="radio_btn"
              @change="onChange"
              value="Studio"
              id="tab-2"
            />
            <label for="tab-2" class="segmented-control__2">
              <p>Studio</p></label
            >

            <input
              type="radio"
              name="radio2"
              v-model="radio_btn"
              @change="onChange"
              value="Calendar"
              id="tab-3"
            />
            <label for="tab-3" class="segmented-control__3">
              <p>Calendar</p></label
            >

            <div class="segmented-control__color"></div>
          </div>
          <br />
        </div>
      </div>
      <br />
      <br />
      <!-- END -->
      <!-- ======================================== Detail Tabs ===================================  -->
      <!-- ======================================== Show Studio =================================== -->
      <div class="bv-example-row" v-if="radio_btn === 'Studio'">
        <div class="card-columns">
          <div class="card card-order-list card-margin calendar-border">
            <div class="card-body">
              <!-- <div
                class="row"
                v-if="
                  check_status_studio_room.length === 0 ||
                  check_status_studio_room.length === null
                "
              >
                <div class="col-xl-2 col-lg-2 col-md-2 col-xs-0"></div>
                <div class="col-xl-8 col-lg-8 col-md-8 col-xs-12">
                  <br />
                  <div class="chip">
                    <div class="chip__icon">
                      <i
                        class="fa-regular fa-face-sad-tear"
                        style="color: Tomato"
                      ></i>
                    </div>
                    <p>ไม่มีรายการจอง</p>
                    <div class="chip__close">
                      
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-xs-0"></div>
              </div> -->

              <div class="card-columns-left-item">
                <span v-for="(stu, inc) in histories" :key="inc">
                  <!-- ======================================== ### เช้า ### ============================================= -->
                  <div></div>

                  <!-- ======================================== Studio 1 ================================================ -->
                  <div
                    class="card card-order-list card-margin calendar-border"
                    v-if="stu.room_id === 8"
                  ></div>

                  <!-- ======================================== END ===================================================== -->

                  <!-- ======================================== Studio 2 ================================================ -->
                  <div
                    class="card card-order-list card-margin calendar-border"
                    v-if="stu.room_id === 9"
                  ></div>

                  <!-- ======================================== END ===================================================== -->

                  <!-- ======================================== SoundRecord ============================================== -->
                  <div
                    class="card card-order-list card-margin calendar-border"
                    v-if="stu.room_id === 10"
                  ></div>

                  <!-- ======================================== END ====================================================== -->

                  <!-- ======================================== ### END เช้า ### ========================================== -->

                  <!-- ======================================== บ่าย ======================================================  -->
                  <div
                    class="card card-order-list card-margin calendar-border"
                    v-if="
                      stu.room_id === 8 ||
                      stu.room_id === 9 ||
                      stu.room_id === 10
                    "
                  >
                    <!-- เหลือง -->
                    <div
                      v-if="stu.trans_status === 'booked'"
                      class="card-header card-status-booking"
                      style="color: #c20404"
                    >
                      <b>{{ stu.trans_status }}</b>
                    </div>
                    <!-- ม่วง-->
                    <div
                      v-if="stu.trans_status === 'confirmed'"
                      class="card-header card-status-booking"
                      style="color: #b505f5"
                    >
                      <b>{{ stu.trans_status }}</b>
                    </div>
                    <!-- น้ำเงิน -->
                    <div
                      v-if="stu.trans_status === 'approved'"
                      class="card-header card-status-booking"
                      style="color: #08909a"
                    >
                      <b>{{ stu.trans_status }}</b>
                    </div>

                    <!-- เขียว -->
                    <div
                      v-if="stu.trans_status === 'completed'"
                      class="card-header card-status-booking"
                      style="color: #05900c"
                    >
                      <b>{{ stu.trans_status }}</b>
                    </div>
                    <div class="card-body text-left">
                      <b-row>
                        <b-col cols="5">
                          <span> Room name </span>
                        </b-col>
                        <b-col cols="7" class="room-name">
                          <span style="font-size: 14px">
                            &nbsp; : &nbsp;{{ stu.room_name }}
                          </span>
                        </b-col>

                        <!-- Name -->
                        <b-col cols="5">
                          <span> Name </span>
                        </b-col>
                        <b-col cols="7" class="room-name">
                          <span> : &nbsp;{{ stu.whois_std_name }} </span>
                        </b-col>
                        <!-- Std__code -->
                        <b-col cols="5">
                          <span> Student code </span>
                        </b-col>
                        <b-col cols="7" class="room-name">
                          <span> : &nbsp;{{ stu.whois_std_code }} </span>
                        </b-col>
                      </b-row>
                      <hr />
                      <b-row>
                        <b-col cols="5">
                          <span>Objective</span>
                        </b-col>
                        <b-col cols="7" class="room-name">
                          : &nbsp;<b> {{ stu.usefor_name }}</b>
                        </b-col>
                        <b-col cols="5">
                          <span>Booking time</span>
                        </b-col>
                        <b-col cols="7" class="room-name">
                          &nbsp;&nbsp;: &nbsp;
                          <span style="color: red">
                            <b style="font-size: 20px">
                              <b-badge variant="danger" class="t-0">
                                {{ stu.time_begin }} -
                                {{ stu.time_end }}</b-badge
                              >
                            </b></span
                          >
                        </b-col>

                        <b-col cols="5">
                          <span>Date</span>
                        </b-col>
                        <b-col cols="7" class="room-name">
                          <span>
                            : &nbsp;<b>{{ stu.meeting_date | moment }}</b></span
                          >
                        </b-col>
                      </b-row>

                      <div
                        class="card-approve"
                        v-if="stu.trans_status === 'booked'"
                      >
                        <!-- =========================================== ยกเลิกการจอง studio =========================== -->
                        <!-- <div class="row">
                          <div class="col-lg-8 col-md-8 col-sm-8"></div>
                          <div class="col-lg-4 col-md-4 col-sm-4">
                            <b-button
                        class="btn btn-secondary p-6 m-2 pull-right"
                        
                        v-b-modal="
                        'modal-cancel-room-studio' +inc"
                        >ยกเลิก</b-button
                      >
                          </div>
                         </div> -->
                        <!-- <div class="p-1"></div> -->

                        <!-- =========================================== END ======================================= -->
                        <!-- ============================================= Modal alert studio ======================== -->
                        <!-- =========================================== Modal cancel room afternoon =================== -->
                        <!-- <b-modal
                           :id="'modal-cancel-room-studio'+inc"
                           size="sm"
                           footer-class="p-2"
                           header-class="p-2"
                           centered
                           class="modal-cancel-roomm"
                        
                         >
                           <h4 class="my-4">กรุณากด ยืนยัน เพื่อยกเลิกการจองห้อง </h4>
                           <template #modal-title>
                             <h5 class="m-1"> <b>ยกเลิกการจอง</b></h5>
                           </template>
             
                           <template #modal-footer="{ ok, cancel }">
                             <b-form
                             @submit.prevent="cancelRoom('ยกเลิกการจองห้อง-stu'+inc)"
                           >
                           <b-button   
                           size=""
                           class="b-between block"
                           variant="success"
                           data-dismiss="modal"
                           type="submit"
                           @click="ok()"
                         >
                           ยืนยัน
                         </b-button>
             
                         <b-button
                           size=""
                           class="b-between"
                           variant="secondary"
                           @click="cancel()"
                         >
                           เอาไว้ก่อน
                         </b-button>
                           </b-form>
                            
                           </template>
                         </b-modal> -->
                        <!-- ========================================== END ======================================= -->
                        <!-- ============================================= END ======================================== -->

                        <!-- Cancel -->
                        <!-- <span
                        v-if="time >= '09:00' && stu.time_begin === '08:30'"
                      >
                        <br />

                        <b-modal
                          :id="'modal-cancle-studio-moorning' + stu.order_id"
                          header-border-variant="white"
                          class="border-bottom-0"
                          header-bg-variant="danger"
                          hide-header
                          footer-border-variant="white"
                          slot="modal-footer"
                        >
                        
                          <div class="text-center mt-3">
                            <img
                              src="../../assets/icons/cancel.gif"
                              alt=""
                              width="50%"
                              height="auto"
                              class="rounded-circle"
                            />
                          </div>
                         
                        
                          <template #modal-footer="{ ok,cancel }">
                            <b-form @submit.prevent="end(stu.order_token)">
                            <b-button
                              size="lg"
                              class="b-between"
                              variant="success"
                              data-dismiss="modal"
                              type="submit"
                              @click="ok()"
                            >
                              OK
                            </b-button>

                            <b-button
                              size="lg"
                              class="b-between"
                              variant="danger"
                              @click="cancel()"
                            >
                              No
                            </b-button>
                          </b-form>
                          </template>
                        
                        </b-modal>

                        <b-button
                          pill
                          variant="outline-secondary"
                          class="btn-floating-cancle-studio"
                          v-b-modal="
                            'modal-cancle-studio-moorning' + stu.order_id
                          "
                        >
                          cancel
                        </b-button>
                      </span>
                      <span
                        v-if="time >= '13:30' && stu.time_begin === '13:00'"
                      >
                        <br />
                        <b-button
                          pill
                          variant="outline-secondary"
                          class="btn-floating-cancle-studio"
                          v-b-modal="
                            'modal-cancle-studio-afternoon' + stu.order_id
                          "
                         
                        >
                          cancel
                        </b-button>
                      </span> -->
                      </div>

                      <br
                        v-if="
                          stu.trans_status === 'confirmed' ||
                          stu.trans_status === 'approved'
                        "
                      />
                      <br
                        v-if="
                          stu.trans_status === 'confirmed' ||
                          stu.trans_status === 'approved'
                        "
                      />
                      <div
                        class="card-approve"
                        v-if="stu.trans_status === 'confirmed'"
                      >
                        <!--  -->

                        <b-button
                          pill
                          class="btn-floating-approve btn-block"
                          v-b-modal="'modal-studio' + stu.order_id"
                          variant="outline-success"
                          v-if="!statusalert"
                        >
                          Approve
                        </b-button>
                        <!-- @click="approve(stu.order_token)"
                         -->
                        <b-modal
                          :id="'modal-studio' + stu.order_id"
                          header-border-variant="white"
                          class="border-bottom-0"
                          header-bg-variant=""
                          size="lg"
                          footer-border-variant="white"
                          slot="modal-footer"
                        >
                          <template #modal-title>
                            <h4>
                              อนุญาตให้ใช้ห้อง
                              <b class="text-danger">{{ stu.room_name }} </b>
                              ใช่หรือไม่?
                            </h4>
                          </template>
                          <div class="text-center">
                            <img
                              src="../../assets/icons/approve.gif"
                              alt=""
                              width="30%"
                              height="auto"
                              class="rounded-circle border-bottom-0"
                            />
                          </div>

                          <template #modal-footer="{ ok, cancel }">
                            <div style="justify-content: center">
                              <!--  -->
                              <b-form
                                @submit.prevent="approve(stu.order_token)"
                              >
                                <b-button
                                  size="lg"
                                  class="b-between block"
                                  variant="outline-success"
                                  data-dismiss="modal"
                                  type="submit"
                                  @click="ok()"
                                  pill
                                >
                                  อนุญาต
                                </b-button>

                                <b-button
                                  pill
                                  size="lg"
                                  class="b-between"
                                  variant="outline-danger"
                                  @click="cancel()"
                                >
                                  ยกเลิก
                                </b-button>
                              </b-form>
                            </div>
                          </template>
                        </b-modal>
                        <!-- <b-button
                        pill
                        variant="outline-success"
                        class="btn-floating-approve btn-block"
                        @click="approve(stu.order_token)"
                        v-if="!statusalert"
                      >
                        Approve
                      </b-button> -->
                        <!-- <br /> -->
                      </div>
                      <div
                        class="card-approve"
                        v-if="stu.trans_status === 'approved'"
                      >
                        <!-- @click="end(stu.order_id)" -->
                        <!-- <button class="btn btn-floating btn-secondary pull-right" style="margin-right: 10px;">ยกเลิก</button> -->

                        <b-button
                          v-if="!statusalert"
                          variant="outline-danger"
                          class="btn-floating-approve"
                          @click="end(stu.order_token)"
                          pill
                        >
                          Done
                        </b-button>
                        <!-- <br /> -->
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END Studio -->
      <!-- ===================================== calendar Full =================================== -->
      <div class="row" v-if="radio_btn === 'Calendar'">
        <div class="col">
          <div class="card card-order-list border-light shadow-sm">
            <div class="card-body">
              <FullCalendar
                :options="calendarOptions"
                ref="fullCalendar"
                :available-dates="{ start: new Date(), end: null }"
              />
            </div>
          </div>
        </div>
      </div>
      <br />
      <!-- End calendar-->
      <!-- End Detail Tabs -->
    </div>
    <!-- END container -->
    <!-- ============================================== Room =================================== -->
    <div class="container-fluid" v-if="radio_btn === ''">
      <div class="row">
        <div class="col"></div>
        <div class="col-10">
          <div class="card-columns-two">
            <!-- ================================ Morning ====================================-->
            <div class="card-columns">
              <div class="card card-order-list calendar-border">
                <div class="card-body">
                  <div class="card-header text-capitalize">
                    <h5><b>ช่วงเช้า</b></h5>
                  </div>
                  <div class="card-body">
                    <!-- ====================================== Cancel ========================================-->
                    <!-- <div class="card-columns-two">
                      <span>
                        <span>
                          <div
                            class="card card-order-list card-margin capitalize-canceled"
                          >
                            <div class="title">
                              <h4><b>MEETING 3A Canceled</b></h4>
                            </div>
                            <div class="card-body text-left">
                              <p style="font-size: 10px">
                                ***รายการนี้ถูกยกเลิก
                                กรุณานำกุญแจออกจากตู้ล็อกเกอร์
                              </p>
                              <p>Locker number: 035</p>
                              <p>Password: 57438</p>
                              <b-button
                              v-b-modal.modal-cancel-room
                              class="btn btn-danger pull-right"
                              >clear</b-button
                            >
                             
                            </div>
                          </div>
                        </span>
                      </span>
                    </div> -->
                    <!-- ================================================== Modal Clear ============================================== -->

                    <b-modal
                      id="modal-cancel-room"
                      size="sm"
                      headerClass="p-0 border-bottom-0"
                      footerClass="p-0 border-top-0"
                      centered
                      hide-header
                      class="modal-cancel-room"
                    >
                      <h5 class="my-4 text-center">ฉันนำกุญแจออกจากตู้แล้ว</h5>

                      <template #modal-footer="{ ok, cancel }">
                        <b-form @submit.prevent="cancelRoom('Clear Locker')">
                          <b-button
                            size=""
                            class="b-between block"
                            variant="outline-success"
                            data-dismiss="modal"
                            type="submit"
                            pill
                            @click="ok()"
                          >
                            ยืนยัน
                          </b-button>

                          <b-button
                            size=""
                            class="b-between"
                            variant="outline-secondary"
                            pill
                            @click="cancel()"
                          >
                            เอาไว้ก่อน
                          </b-button>
                        </b-form>
                      </template>
                    </b-modal>
                    <!-- ================================================= END ======================================================= -->
                    <!-- ===================== -->
                    <!-- <div class="card-column-two">
                      <span v-for="(inlocker, ind) in histories" :key="ind">
                        <span
                          v-if="
                            (inlocker.room_id === 1 ||
                              inlocker.room_id === 2 ||
                              inlocker.room_id === 3 ||
                              inlocker.room_id === 4 ||
                              inlocker.room_id === 5 ||
                              inlocker.room_id === 6 ||
                              inlocker.room_id === 7) &&
                            inlocker.time_begin === '08:30'
                          "
                        >
                          <div
                            class="card card-order-list card-margin calendar-border"
                            v-if="
                              choosedDay2.dateFormat.moment ===
                                inlocker.meeting_date.moment &&
                              inlocker.trans_status === 'inlocker' &&
                              inlocker.time_begin === '08:30'
                            "
                          >
                            <div class="card-header card-status-booking">
                              <div class="card-body">

                              </div>
                            </div>
                          </div>
                        </span>
                      </span>
                    </div> -->
                    <!-- ===================================== END =========================================== -->
                    <!-- <hr /> -->
                    <!-- ====================================== Booking ======================================= -->
                    <div class="card-columns-two">
                      <span v-for="(moorning, ind) in histories" :key="ind">
                        <span
                          v-if="
                            moorning.room_id === 1 ||
                            moorning.room_id === 2 ||
                            moorning.room_id === 3 ||
                            moorning.room_id === 4 ||
                            moorning.room_id === 5 ||
                            moorning.room_id === 6 ||
                            (moorning.room_id === 7 &&
                              moorning.time_begin === '08:30')
                          "
                        >
                          <div
                            class="card card-order-list card-margin calendar-border"
                            v-if="
                              choosedDay2.dateFormat.moment ===
                                moorning.meeting_date.moment &&
                              moorning.trans_status === 'booked' &&
                              moorning.time_begin === '08:30'
                            "
                          >
                            <div
                              v-if="moorning.trans_status === 'booked'"
                              class="card-header card-status-booking"
                            >
                              <b class="text-warning">{{
                                moorning.trans_status
                              }}</b>
                            </div>
                            <div class="card-body text-left">
                              <span v-if="!readMore[moorning.order_id]">
                                <b-row>
                                  <!-- Time -->
                                  <b-col cols="4">
                                    <span> Time </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    : &nbsp;
                                    <span style="color: warning">
                                      <b style="font-size: 20px">
                                        <b-badge variant="warning" class="t-0">
                                          {{ moorning.time_begin }} -
                                          {{ moorning.time_end }}</b-badge
                                        >
                                      </b></span
                                    >
                                  </b-col>
                                  <!-- Room Name -->
                                  <b-col cols="4">
                                    <span>Room </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span style="font-size: 15px">
                                      : &nbsp;{{ moorning.room_name }}
                                      
                                    </span>
                                    <span
                                        v-if="!readMore[moorning.order_id]"
                                        @click="showMore(moorning.order_id)"
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >เพิ่มเติม</span>
                                    
                                  </b-col>
                                </b-row>
                                <hr />
                                <!-- <b-row>
                                  Locker
                                  <b-col cols="4">
                                    <span> Locker </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        moorning.locker_number
                                      }}</b>
                                    </span>
                                  </b-col>
                                  password
                                  <b-col cols="4">
                                    <span>Password</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        moorning.locker_passcode
                                      }}</b>

                                      <span
                                        v-if="!readMore[moorning.order_id]"
                                        @click="showMore(moorning.order_id)"
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >เพิ่มเติม</span
                                      ></span
                                    >
                                  </b-col>
                                </b-row> -->
                              </span>
                              <!-- END -->
                              <span v-if="readMore[moorning.order_id]">
                                <b-row>
                                  <!-- Time -->
                                  <b-col cols="4">
                                    <span> Time </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    : &nbsp;
                                    <span style="color: red">
                                      <b style="font-size: 20px">
                                        <b-badge variant="danger" class="t-0">
                                          {{ moorning.time_begin }} -
                                          {{ moorning.time_end }}</b-badge
                                        >
                                      </b></span
                                    >
                                  </b-col>
                                  <!-- Room Name -->
                                  <b-col cols="4">
                                    <span>Room </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span style="font-size: 15px">
                                      : &nbsp;{{ moorning.room_name }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <hr />

                                <b-row>
                                  <!-- Locker -->
                                  <b-col cols="4">
                                    <span> Locker </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        moorning.locker_number
                                      }}</b>
                                    </span>
                                  </b-col>
                                  <!-- password -->
                                  <b-col cols="4">
                                    <span>Password</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        moorning.locker_passcode
                                      }}</b>
                                    </span>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col cols="4">
                                    <span>Name</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        moorning.whois_std_name
                                      }}</b>
                                    </span>
                                  </b-col>

                                  <b-col cols="4">
                                    <span>Std Code</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        moorning.whois_std_code
                                      }}</b>
                                    </span>
                                  </b-col>

                                  <b-col cols="4">
                                    <span>Date</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        moorning.meeting_date | moment
                                      }}</b>
                                      <span
                                        v-if="readMore[moorning.order_id]"
                                        @click="showLess(moorning.order_id)"
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >ย่อ</span
                                      >
                                    </span>
                                  </b-col>
                                </b-row>
                              </span>
                              <br v-if="moorning.trans_status === 'booked'" />
                              <br v-if="moorning.trans_status === 'booked'" />

                              <span
                                class="text-warning"
                                v-if="moorning.trans_status === 'booked'"
                              >
                                <div class="card-approve">
                                  <b-button
                                    pill
                                    variant="outline-success"
                                    class="btn-floating-approve btn-block"
                                    v-b-modal="
                                      'modal-confirm-meeting-moorning' +
                                      moorning.order_id
                                    "
                                  >
                                    Confirm
                                  </b-button>
                                  <b-modal
                                    :id="
                                      'modal-confirm-meeting-moorning' +
                                      moorning.order_id
                                    "
                                    header-border-variant="white"
                                    class="border-bottom-0"
                                    header-bg-variant=""
                                    size="sm"
                                    footer-border-variant="white"
                                    slot="modal-footer"
                                  >
                                    <template #modal-title>
                                      <h6>
                                        ยืนยันการจองห้อง <b class="text-danger">{{
                                          moorning.room_name
                                        }}</b>
                                        <!-- กุญแจห้อง<b class="text-danger">{{
                                          moorning.room_name
                                        }}</b>
                                        อยู่ในตู้
                                        <b class="text-danger">{{
                                          moorning.locker_number
                                        }}</b>
                                        แล้ว ใช่หรือไม่? -->
                                      </h6>
                                    </template>
                                    <div class="text-center">
                                      <img
                                        src="../../assets/icons/locker_in_color.gif"
                                        alt=""
                                        width="30%"
                                        height="auto"
                                        class="rounded-circle border-bottom-0"
                                      />
                                    </div>

                                    <template #modal-footer="{ ok, cancel }">
                                      <div style="justify-content: center">
                                        <b-form
                                          @submit.prevent="
                                            inlocker(moorning.order_id)
                                          "
                                        >
                                          <b-button
                                            size="md"
                                            class="b-between block"
                                            variant="outline-success"
                                            data-dismiss="modal"
                                            type="submit"
                                            @click="ok()"
                                            pill
                                          >
                                           ยืนยัน
                                          </b-button>

                                          <b-button
                                            pill
                                            size="md"
                                            class="b-between"
                                            variant="outline-danger"
                                            @click="cancel()"
                                          >
                                           เอาไว้ก่อน
                                          </b-button>
                                        </b-form>
                                      </div>
                                    </template>
                                  </b-modal>
                                </div>
                              </span>
                            </div>
                          </div>
                        </span>
                      </span>
                    </div>
                    <!-- END -->
                    <!-- ======================================= In locker Status ================================ -->
                    <div class="card-columns-two">
                      <span v-for="(inlocker, ind) in histories" :key="ind">
                        <span
                          v-if="
                            (inlocker.room_id === 1 ||
                              inlocker.room_id === 2 ||
                              inlocker.room_id === 3 ||
                              inlocker.room_id === 4 ||
                              inlocker.room_id === 5 ||
                              inlocker.room_id === 6 ||
                              inlocker.room_id === 7) &&
                            inlocker.time_begin === '08:30'
                          "
                        >
                          <div
                            class="card card-order-list card-margin calendar-border"
                            v-if="
                              choosedDay2.dateFormat.moment ===
                                inlocker.meeting_date.moment &&
                              inlocker.trans_status === 'inlocker' &&
                              inlocker.time_begin === '08:30'
                            "
                          >
                            <!-- ม่วง -->
                            <div
                              v-if="inlocker.trans_status === 'inlocker'"
                              class="card-header card-status-booking"
                            >
                              <b style="color: #b505f5">{{
                                inlocker.trans_status
                              }}</b>
                            </div>
                            <div class="card-body text-left">
                              <span v-if="!readMore[inlocker.order_id]">
                                <b-row>
                                  <!-- Time -->
                                  <b-col cols="4">
                                    <span> Time </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    : &nbsp;
                                    <span>
                                      <b style="font-size: 20px">
                                        <b-badge
                                          variant="danger"
                                          class="t-0"
                                          style="background-color: #b505f5"
                                        >
                                          {{ inlocker.time_begin }} -
                                          {{ inlocker.time_end }}</b-badge
                                        >
                                      </b></span
                                    >
                                  </b-col>
                                  <!-- Room Name -->
                                  <b-col cols="4">
                                    <span>Room </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span style="font-size: 15px">
                                      : &nbsp;{{ inlocker.room_name }}
                                    </span>
                                    <br/>
                                    <span
                                      v-if="!readMore[inlocker.order_id]"
                                      @click="showMore(inlocker.order_id)"
                                    >
                                      <!-- : &nbsp;<b>{{
                                        inlocker.locker_passcode
                                      }}</b> -->
                                      <span 
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 0px;
                                        "
                                       >เพิ่มเติม</span
                                      >
                                    </span>
                                  </b-col>
                                </b-row>
                                <hr />

                                <b-row>
                                 
                                  <b-col cols="12" class="room-name">
                                    <router-link  :to="'/locker/'+
                                        inlocker.locker_number"
                                    class="nav-link pull-right" target="_blank">
                                    <b-button variant="info" pill size="md" pull-right>รับกุญแจ</b-button>
                                      
                                    </router-link>
                                  
                                  </b-col>
                                  <!-- Locker
                                  <b-col cols="4">
                                    <span> Locker </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        inlocker.locker_number
                                      }}</b>
                                    </span>
                                  </b-col>
                                  password
                                  <b-col cols="4">
                                    <span>Password</span>
                                  </b-col> -->
                                  
                                </b-row>
                              </span>
                              <span v-if="readMore[inlocker.order_id]">
                                <b-row>
                                  <!-- Time -->
                                  <b-col cols="4">
                                    <span> Time </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    : &nbsp;
                                    <span style="color: red">
                                      <b style="font-size: 20px">
                                        <b-badge variant="danger" class="t-0">
                                          {{ inlocker.time_begin }} -
                                          {{ inlocker.time_end }}</b-badge
                                        >
                                      </b></span
                                    >
                                  </b-col>
                                  <!-- Room Name -->
                                  <b-col cols="4">
                                    <span>Room </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span style="font-size: 15px">
                                      : &nbsp;{{ inlocker.room_name }}
                                      <!-- {{ his.whois_std_name.slice(0, 17) }}
                              <span v-if="his.whois_std_name.length > 17">
                                ...</span
                              > -->
                                    </span>
                                  </b-col>
                                </b-row>
                                <hr />

                                <b-row>
                                  <!-- Locker -->
                                  <b-col cols="4">
                                    <span> Locker </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        inlocker.locker_number
                                      }}</b>
                                    </span>
                                  </b-col>
                                  <!-- password -->
                                  <b-col cols="4">
                                    <span>Password</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        inlocker.locker_passcode
                                      }}</b>
                                    </span>
                                  </b-col>
                                </b-row>

                                <b-row>
                                  <b-col cols="4">
                                    <span>Name</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        inlocker.whois_std_name
                                      }}</b>
                                    </span>
                                  </b-col>

                                  <b-col cols="4">
                                    <span>Std Code</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        inlocker.whois_std_code
                                      }}</b>
                                    </span>
                                  </b-col>

                                  <b-col cols="4">
                                    <span>Date</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        inlocker.meeting_date | moment
                                      }}</b>

                                      <span
                                        v-if="readMore[inlocker.order_id]"
                                        @click="showLess(inlocker.order_id)"
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >ย่อ</span
                                      >
                                    </span>
                                  </b-col>
                                </b-row>
                              </span>

                              <div class="pt-3"></div>
                              <span class="text-warning">
                                <div class="card-approve text-right">
                                  <!-- <b-button v-b-modal.modal-center class="btn btn-danger"> cancel</b-button> -->

                                  <b-modal
                                    id="modal-center"
                                    centered
                                    header-border-variant="white"
                                    class="border-bottom-0"
                                    header-bg-variant=""
                                    size="lg"
                                    footer-border-variant="white"
                                    slot="modal-footer"
                                  >
                                    <h5 class="my-4">
                                      ชื่อ
                                      <b class="text-danger">{{
                                        inlocker.whois_std_name
                                      }}</b>
                                      ต้องการยกเลิกใช่หรือไม่?
                                    </h5>
                                    <template #modal-title>
                                      <h4>
                                        ห้อง<b class="text-danger">{{
                                          inlocker.room_name
                                        }}</b>
                                      </h4>
                                    </template>
                                    <template #modal-footer="{ cancel }">
                                      <div style="justify-content: center">
                                        <b-form
                                          @submit.prevent="
                                            inlocker(inlocker.order_id)
                                          "
                                        >
                                          <b-button
                                            size="lg"
                                            class="b-between block"
                                            variant="outline-success"
                                            data-dismiss="modal"
                                            type="submit"
                                            pill
                                          >
                                            ยืนยัน
                                          </b-button>
                                          <span class="px-2"></span>

                                          <b-button
                                            pill
                                            size="lg"
                                            class="b-between"
                                            variant="outline-danger"
                                            @click="cancel()"
                                          >
                                            ปิด
                                          </b-button>
                                        </b-form>
                                      </div>
                                    </template>
                                  </b-modal>
                                </div>
                              </span>
                            </div>
                            <!-- =========================================== ยกเลิกการจอง เช้า =========================== -->
                            <!-- <button class="btn btn-secondary pull-right" style="margin-right: 10px;">ยกเลิก</button> -->

                            <!-- <div class="row">
                            <div class="col-lg-8 col-md-8 col-sm-8"></div>
                            <div class="col-lg-4 col-md-4 col-sm-4">
                              <b-button
                          class="btn btn-secondary p-6 m-1 pull-right"
                          
                          v-b-modal="
                          'modal-cancel-room-morning' +ind"
                          >ยกเลิก</b-button
                        >
                            </div>
                           </div>
                           <div class="p-1"></div> -->
                            <!-- =========================================== modal cancel morning ====================== -->

                            <!-- <b-modal
                            :id="'modal-cancel-room-morning'+ind"
                            size="sm"
                            footer-class="p-2"
                            header-class="p-2"
                            centered
                            class="modal-cancel-roomm"
                         
                          >
                            <h4 class="my-4">กรุณากด ยืนยัน เพื่อยกเลิกการจองห้อง </h4>
                            <template #modal-title>
                              <h5 class="m-1"> <b>ยกเลิกการจอง</b></h5>
                            </template>
              
                            <template #modal-footer="{ ok, cancel }">
                              <b-form
                              @submit.prevent="cancelRoom('ยกเลิกการจองห้อง-เช้า'+ind)"
                            >
                            <b-button
                            size=""
                            class="b-between block"
                            variant="success"
                            data-dismiss="modal"
                            type="submit"
                            @click="ok()"
                          >
                            ยืนยัน
                          </b-button>
              
                          <b-button
                            size=""
                            class="b-between"
                            variant="secondary"
                            @click="cancel()"
                          >
                            เอาไว้ก่อน
                          </b-button>
                            </b-form>
                             
                            </template>
                          </b-modal> -->
                            <!-- =========================================== END ======================================= -->
                          </div>
                        </span>
                      </span>
                    </div>
                    <!-- END -->
                    <!-- ======================================= Borrowed Status ================================ -->
                    <div class="card-columns-two">
                      <span v-for="(borrowed, ind) in histories" :key="ind">
                        <span
                          v-if="
                            (borrowed.room_id === 1 ||
                              borrowed.room_id === 2 ||
                              borrowed.room_id === 3 ||
                              borrowed.room_id === 4 ||
                              borrowed.room_id === 5 ||
                              borrowed.room_id === 6 ||
                              borrowed.room_id === 7) &&
                            borrowed.time_begin === '08:30'
                          "
                        >
                          <div
                            class="card card-order-list card-margin calendar-border"
                            v-if="
                              choosedDay2.dateFormat.moment ===
                                borrowed.meeting_date.moment &&
                              borrowed.trans_status === 'borrowed' &&
                              borrowed.time_begin === '08:30'
                            "
                          >
                            <div
                              v-if="borrowed.trans_status === 'borrowed'"
                              class="card-header card-status-booking"
                            >
                              <b style="color: #05900c">{{
                                borrowed.trans_status
                              }}</b>
                            </div>

                            <div class="card-body text-left">
                              <span v-if="!readMore[borrowed.order_id]">
                                <b-row>
                                  <!-- Time -->
                                  <b-col cols="4">
                                    <span> Time </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    : &nbsp;
                                    <span>
                                      <b style="font-size: 20px">
                                        <b-badge
                                          variant="danger"
                                          class="t-0"
                                          style="background-color: #05900c"
                                        >
                                          {{ borrowed.time_begin }} -
                                          {{ borrowed.time_end }}</b-badge
                                        >
                                      </b></span
                                    >
                                  </b-col>
                                  <!-- Room Name -->
                                  <b-col cols="4">
                                    <span>Room </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span style="font-size: 15px">
                                      : &nbsp;{{ borrowed.room_name }}
                                    </span>
                                    <span
                                        v-if="!readMore[borrowed.order_id]"
                                        @click="showMore(borrowed.order_id)"
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >เพิ่มเติม</span
                                      >
                                  </b-col>
                                </b-row>
                                <hr />

                                <!-- <b-row>
                                  Locker
                                  <b-col cols="4">
                                    <span> Locker </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        borrowed.locker_number
                                      }}</b>
                                    </span>
                                  </b-col>
                                  password
                                  <b-col cols="4">
                                    <span>Password</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        borrowed.locker_passcode
                                      }}</b>
                                      <span
                                        v-if="!readMore[borrowed.order_id]"
                                        @click="showMore(borrowed.order_id)"
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >เพิ่มเติม</span
                                      >
                                    </span>
                                  </b-col>
                                </b-row> -->
                              </span>
                              <span v-if="readMore[borrowed.order_id]">
                                <b-row>
                                  <!-- Time -->
                                  <b-col cols="4">
                                    <span> Time </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    : &nbsp;
                                    <span style="color: red">
                                      <b style="font-size: 20px">
                                        <b-badge variant="danger" class="t-0">
                                          {{ borrowed.time_begin }} -
                                          {{ borrowed.time_end }}</b-badge
                                        >
                                      </b></span
                                    >
                                  </b-col>
                                  <!-- Room Name -->
                                  <b-col cols="4">
                                    <span>Room </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span style="font-size: 15px">
                                      : &nbsp;{{ borrowed.room_name }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <hr />

                                <b-row>
                                  <!-- Locker -->
                                  <b-col cols="4">
                                    <span> Locker </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        borrowed.locker_number
                                      }}</b>
                                    </span>
                                  </b-col>
                                  <!-- password -->
                                  <b-col cols="4">
                                    <span>Password</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        borrowed.locker_passcode
                                      }}</b>
                                    </span>
                                  </b-col>
                                </b-row>

                                <b-row>
                                  <b-col cols="4">
                                    <span>Name</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        borrowed.whois_std_name
                                      }}</b>
                                    </span>
                                  </b-col>

                                  <b-col cols="4">
                                    <span>Std Code</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        borrowed.whois_std_code
                                      }}</b>
                                    </span>
                                  </b-col>

                                  <b-col cols="4">
                                    <span>Date</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        borrowed.meeting_date | moment
                                      }}</b>
                                      <span
                                        v-if="readMore[borrowed.order_id]"
                                        @click="showLess(borrowed.order_id)"
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >ย่อ</span
                                      >
                                    </span>
                                  </b-col>
                                </b-row>
                              </span>
                            </div>
                          </div>
                        </span>
                      </span>
                    </div>
                    <!-- END -->
                    <!-- =========================================== Return ============================= -->
                    <div class="card-columns-two">
                      <span v-for="(returned, ind) in histories" :key="ind">
                        <span
                          v-if="
                            (returned.room_id === 1 ||
                              returned.room_id === 2 ||
                              returned.room_id === 3 ||
                              returned.room_id === 4 ||
                              returned.room_id === 5 ||
                              returned.room_id === 6 ||
                              returned.room_id === 7) &&
                            returned.time_begin === '08:30'
                          "
                        >
                          <div
                            class="card card-order-list card-margin calendar-border"
                            v-if="
                              choosedDay2.dateFormat.moment ===
                                returned.meeting_date.moment &&
                              returned.trans_status === 'returned' &&
                              returned.time_begin === '08:30'
                            "
                          >
                            <div
                              v-if="returned.trans_status === 'returned'"
                              class="card-header card-status-booking"
                            >
                              <b style="color: #616161">{{
                                returned.trans_status
                              }}</b>
                            </div>

                            <div class="card-body text-left">
                              <b-row>
                                <b-col cols="5">
                                  <span> Room name </span>
                                </b-col>
                                <b-col cols="7" class="room-name">
                                  <span style="color: #616161">
                                    : &nbsp;<b>{{ returned.room_name }}</b>
                                  </span>
                                </b-col>
                                <b-col cols="5">
                                  <span> Name </span>
                                </b-col>
                                <b-col cols="7" class="room-name">
                                  <span>
                                    : &nbsp; {{ returned.whois_std_name }}
                                  </span>
                                </b-col>
                                <b-col cols="5">
                                  <span> Student code </span>
                                </b-col>
                                <b-col cols="7" class="room-name">
                                  <span>
                                    : &nbsp;{{ returned.whois_std_code }}
                                  </span>
                                </b-col>
                              </b-row>
                            </div>

                            <!-- card -footer -->
                          </div>
                        </span>
                      </span>
                    </div>

                    <!-- END -->
                  </div>
                </div>
              </div>
            </div>
            <!-- END -->
            <!-- =============================== After noon  =============================== -->
            <div class="card-columns">
              <div class="card card-order-list card-margin calendar-border">
                <div class="card-body">
                  <div class="card-header text-capitalize">
                    <h5><b>ช่วงบ่าย</b></h5>
                  </div>
                  <div class="card-body">
                    <!-- ====================================== Cancel ========================================-->
                    <!-- <div class="card-columns-two">
                      <span>
                        <span>
                          <div
                            class="card card-order-list card-margin capitalize-canceled"
                          >
                            <div class="title">
                              <h4><b>MEETING 4B Canceled</b></h4>
                            </div>
                            <div class="card-body text-left">
                              <p style="font-size: 10px">
                                ***รายการนี้ถูกยกเลิก
                                กรุณานำกุญแจออกจากตู้ล็อกเกอร์
                              </p>
                              <p>Locker number: 034</p>
                              <p>Password: 53338</p>
                              <b-button
                              v-b-modal.modal-cancel-room-afternoon
                              class="btn btn-danger pull-right"
                              >clear</b-button
                            >
                            </div>

                           
                          </div>
                        </span>
                      </span>
                    </div>
                    <hr/> -->
                    <!-- ================================================== Modal Clear ============================================== -->

                    <b-modal
                      id="modal-cancel-room-afternoon"
                      size="sm"
                      headerClass="p-0 border-bottom-0"
                      footerClass="p-0 border-top-0"
                      centered
                      hide-header
                      class="modal-cancel-room-afternoon"
                    >
                      <h5 class="my-4 text-center">ฉันนำกุญแจออกจากตู้แล้ว</h5>

                      <template #modal-footer="{ ok, cancel }">
                        <b-form
                          @submit.prevent="cancelRoom('Clear Locker-after')"
                        >
                          <b-button
                            size=""
                            class="b-between block"
                            variant="outline-success"
                            data-dismiss="modal"
                            type="submit"
                            @click="ok()"
                          >
                            ยืนยัน
                          </b-button>

                          <b-button
                            size=""
                            class="b-between"
                            variant="outline-secondary"
                            @click="cancel()"
                          >
                            เอาไว้ก่อน
                          </b-button>
                        </b-form>
                      </template>
                    </b-modal>
                    <!-- ================================================= END ======================================================= -->
                    <!-- ======================================= END ========================================= -->
                    <div class="card-columns-two">
                      <!-- ======================================= Booked Status ================================ -->
                      <span v-for="(afternoon, inda) in histories" :key="inda">
                        <span
                          v-if="
                            (afternoon.room_id === 1 ||
                              afternoon.room_id === 2 ||
                              afternoon.room_id === 3 ||
                              afternoon.room_id === 4 ||
                              afternoon.room_id === 5 ||
                              afternoon.room_id === 6 ||
                              afternoon.room_id === 7) &&
                            afternoon.time_begin === '13:00'
                          "
                        >
                          <div
                            class="card card-order-list card-margin calendar-border"
                            v-if="
                              choosedDay2.dateFormat.moment ===
                                afternoon.meeting_date.moment &&
                              afternoon.trans_status === 'booked' &&
                              afternoon.time_begin === '13:00'
                            "
                          >
                            <div
                              v-if="afternoon.trans_status === 'booked'"
                              class="card-header card-status-booking"
                            >
                              <b class="text-warning">{{
                                afternoon.trans_status
                              }}</b>
                            </div>
                            <div class="card-body text-left">
                              <span v-if="!readMore[afternoon.order_id]">
                                <b-row>
                                  <!-- Time -->
                                  <b-col cols="4">
                                    <span> Time </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    : &nbsp;
                                    <span style="color: warning">
                                      <b style="font-size: 20px">
                                        <b-badge variant="warning" class="t-0">
                                          {{ afternoon.time_begin }} -
                                          {{ afternoon.time_end }}</b-badge
                                        >
                                      </b></span
                                    >
                                  </b-col>
                                  <!-- Room Name -->
                                  <b-col cols="4">
                                    <span>Room </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span style="font-size: 15px">
                                      : &nbsp;{{ afternoon.room_name }}
                                    </span>
                                    <span
                                        v-if="!readMore[afternoon.order_id]"
                                        @click="showMore(afternoon.order_id)"
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >เพิ่มเติม</span
                                      >
                                  </b-col>
                                </b-row>
                                <hr />
                                <!-- <b-row>
                                  Locker
                                  <b-col cols="4">
                                    <span> Locker </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        afternoon.locker_number
                                      }}</b>
                                    </span>
                                  </b-col>
                                  password
                                  <b-col cols="4">
                                    <span>Password</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        afternoon.locker_passcode
                                      }}</b>

                                      <span
                                        v-if="!readMore[afternoon.order_id]"
                                        @click="showMore(afternoon.order_id)"
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >เพิ่มเติม</span
                                      ></span
                                    >
                                  </b-col>
                                </b-row> -->
                              </span>
                              <!-- END -->
                              <span v-if="readMore[afternoon.order_id]">
                                <b-row>
                                  <!-- Time -->
                                  <b-col cols="4">
                                    <span> Time </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    : &nbsp;
                                    <span style="color: red">
                                      <b style="font-size: 20px">
                                        <b-badge variant="danger" class="t-0">
                                          {{ afternoon.time_begin }} -
                                          {{ afternoon.time_end }}</b-badge
                                        >
                                      </b></span
                                    >
                                  </b-col>
                                  <!-- Room Name -->
                                  <b-col cols="4">
                                    <span>Room </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span style="font-size: 15px">
                                      : &nbsp;{{ afternoon.room_name }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <hr />

                                <b-row>
                                  <!-- Locker -->
                                  <b-col cols="4">
                                    <span> Locker </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        afternoon.locker_number
                                      }}</b>
                                    </span>
                                  </b-col>
                                  <!-- password -->
                                  <b-col cols="4">
                                    <span>Password</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        afternoon.locker_passcode
                                      }}</b>
                                    </span>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col cols="4">
                                    <span>Name</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        afternoon.whois_std_name
                                      }}</b>
                                    </span>
                                  </b-col>

                                  <b-col cols="4">
                                    <span>Std Code</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        afternoon.whois_std_code
                                      }}</b>
                                    </span>
                                  </b-col>

                                  <b-col cols="4">
                                    <span>Date</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        afternoon.meeting_date | moment
                                      }}</b>
                                      <span
                                        v-if="readMore[afternoon.order_id]"
                                        @click="showLess(afternoon.order_id)"
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >ย่อ</span
                                      >
                                    </span>
                                  </b-col>
                                </b-row>
                              </span>
                              <br v-if="afternoon.trans_status === 'booked'" />
                              <br v-if="afternoon.trans_status === 'booked'" />

                              <span
                                class="text-warning"
                                v-if="afternoon.trans_status === 'booked'"
                              >
                                <div class="card-approve">
                                  <b-button
                                    pill
                                    variant="outline-success"
                                    class="btn-floating-approve btn-block"
                                    v-b-modal="
                                      'modal-confirm-meeting-afternoon' +
                                      afternoon.order_id
                                    "
                                  >
                                    Confirm
                                  </b-button>
                                  <b-modal
                                    :id="
                                      'modal-confirm-meeting-afternoon' +
                                      afternoon.order_id
                                    "
                                    header-border-variant="white"
                                    class="border-bottom-0"
                                    header-bg-variant=""
                                    size="sm"
                                    footer-border-variant="white"
                                    slot="modal-footer"
                                  >
                                    <template #modal-title>
                                      <h6>
                                        ยืนยันการจองห้อง <b class="text-danger">{{
                                         afternoon.room_name
                                        }}</b>
                                      </h6>
                                    </template>
                                    <div class="text-center">
                                      <img
                                        src="../../assets/icons/locker_in_color.gif"
                                        alt=""
                                        width="30%"
                                        height="auto"
                                        class="rounded-circle border-bottom-0"
                                      />
                                    </div>

                                    <template #modal-footer="{ ok, cancel }">
                                      <div style="justify-content: center">
                                        <b-form
                                          @submit.prevent="
                                            inlocker(afternoon.order_id)
                                          "
                                        >
                                          <b-button
                                            size="md"
                                            class="b-between block"
                                            variant="outline-success"
                                            data-dismiss="modal"
                                            type="submit"
                                            @click="ok()"
                                            pill
                                          >
                                           ยืนยัน
                                          </b-button>

                                          <b-button
                                            pill
                                            size="md"
                                            class="b-between"
                                            variant="outline-danger"
                                            @click="cancel()"
                                          >
                                           เอาไว้ก่อน
                                          </b-button>
                                        </b-form>
                                      </div>
                                    </template>
                                  </b-modal>
                                </div>
                              </span>
                            </div>
                          </div>
                        </span>
                      </span>
                    </div>
                    <!-- END -->
                    <!-- ======================================= In locker Status ================================ -->
                    <div class="card-columns-two">
                      <span v-for="(inlocker, ind) in histories" :key="ind">
                        <span
                          v-if="
                            (inlocker.room_id === 1 ||
                              inlocker.room_id === 2 ||
                              inlocker.room_id === 3 ||
                              inlocker.room_id === 4 ||
                              inlocker.room_id === 5 ||
                              inlocker.room_id === 6 ||
                              inlocker.room_id === 7) &&
                            inlocker.time_begin === '13:00'
                          "
                        >
                          <div
                            class="card card-order-list card-margin calendar-border"
                            v-if="
                              choosedDay2.dateFormat.moment ===
                                inlocker.meeting_date.moment &&
                              inlocker.trans_status === 'inlocker' &&
                              inlocker.time_begin === '13:00'
                            "
                          >
                            <!-- ม่วง -->
                            <div
                              v-if="inlocker.trans_status === 'inlocker'"
                              class="card-header card-status-booking"
                            >
                              <b style="color: #b505f5">{{
                                inlocker.trans_status
                              }}</b>
                            </div>
                            <div class="card-body text-left">
                              <span v-if="!readMore[inlocker.order_id]">
                                <b-row>
                                  <!-- <b-col cols="4">
                                        <span>Status</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    : &nbsp;<span style="font-size: 15px; color:#c20404;"> <b>หมดเวลารับกุญแจ กรุณานำกุญแจออกจาก Locker นี้</b></span>
                                  </b-col> -->
                                  <!-- Time -->
                                  <b-col cols="4">
                                    <span> Time </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    : &nbsp;
                                    <span>
                                      <b style="font-size: 20px">
                                        <b-badge
                                          variant="danger"
                                          class="t-0"
                                          style="background-color: #b505f5"
                                        >
                                          {{ inlocker.time_begin }} -
                                          {{ inlocker.time_end }}</b-badge
                                        >
                                      </b></span
                                    >
                                  </b-col>
                                  <!-- Room Name -->
                                  <b-col cols="4">
                                    <span>Room </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span style="font-size: 15px">
                                      : &nbsp;{{ inlocker.room_name }}
                                    </span>
                                    <br/>
                                    <span
                                      v-if="!readMore[inlocker.order_id]"
                                      @click="showMore(inlocker.order_id)"
                                    >
                                       <!-- &nbsp;<b>{{
                                        inlocker.locker_passcode
                                      }}</b> -->
                                      <span
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 0px;
                                        "
                                        >เพิ่มเติม</span
                                      >
                                    </span>
                                  </b-col>
                                </b-row>
                                <hr />

                                <b-row>
                                  <b-col cols="12" class="room-name">
                                    <router-link  :to="'/locker/'+
                                        inlocker.locker_number"
                                    class="nav-link pull-right" target="_blank">
                                    <b-button variant="info" pill size="md" pull-right>รับกุญแจ</b-button>
                                      
                                    </router-link>
                                  
                                  </b-col>
                                  
                                  <!-- Locker
                                  <b-col cols="4">
                                    <span> Locker </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        inlocker.locker_number
                                      }}</b>
                                    </span>
                                  </b-col>
                                  password
                                  <b-col cols="4">
                                    <span>Password</span>
                                  </b-col> -->
                                  <!-- <b-col cols="8" class="room-name">
                                    <span
                                      v-if="!readMore[inlocker.order_id]"
                                      @click="showMore(inlocker.order_id)"
                                    >
                                      : &nbsp;<b>{{
                                        inlocker.locker_passcode
                                      }}</b>
                                      <span
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >เพิ่มเติม</span
                                      >
                                    </span>
                                  </b-col> -->
                                </b-row>
                              </span>
                              <span v-if="readMore[inlocker.order_id]">
                                <b-row>
                                  <!-- <b-col cols="4">
                                    <span>Status</span>
                              </b-col>
                              <b-col cols="8" class="room-name">
                                : &nbsp;<span style="font-size: 15px; color:#c20404;"> <b>หมดเวลารับกุญแจ กรุณานำกุญแจออกจาก Locker นี้</b></span>
                              </b-col> -->
                                  <!-- Time -->
                                  <b-col cols="4">
                                    <span> Time </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    : &nbsp;
                                    <span style="color: red">
                                      <b style="font-size: 20px">
                                        <b-badge variant="danger" class="t-0">
                                          {{ inlocker.time_begin }} -
                                          {{ inlocker.time_end }}</b-badge
                                        >
                                      </b></span
                                    >
                                  </b-col>
                                  <!-- Room Name -->
                                  <b-col cols="4">
                                    <span>Room </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span style="font-size: 15px">
                                      : &nbsp;{{ inlocker.room_name }}
                                      <!-- {{ his.whois_std_name.slice(0, 17) }}
                              <span v-if="his.whois_std_name.length > 17">
                                ...</span
                              > -->
                                    </span>
                                  </b-col>
                                </b-row>
                                <hr />

                                <b-row>
                                  <!-- Locker -->
                                  <b-col cols="4">
                                    <span> Locker </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        inlocker.locker_number
                                      }}</b>
                                    </span>
                                  </b-col>
                                  <!-- password -->
                                  <b-col cols="4">
                                    <span>Password</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        inlocker.locker_passcode
                                      }}</b>
                                    </span>
                                  </b-col>
                                </b-row>

                                <b-row>
                                  <b-col cols="4">
                                    <span>Name</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        inlocker.whois_std_name
                                      }}</b>
                                    </span>
                                  </b-col>

                                  <b-col cols="4">
                                    <span>Std Code</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        inlocker.whois_std_code
                                      }}</b>
                                    </span>
                                  </b-col>

                                  <b-col cols="4">
                                    <span>Date</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        inlocker.meeting_date | moment
                                      }}</b>

                                      <span
                                        v-if="readMore[inlocker.order_id]"
                                        @click="showLess(inlocker.order_id)"
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >ย่อ</span
                                      >
                                    </span>
                                  </b-col>
                                </b-row>
                              </span>
                            </div>

                            <!-- =========================================== ยกเลิกการจอง บ่าย =========================== -->
                            <!-- <button class="btn btn-secondary pull-right" style="margin-right: 10px;">ยกเลิก</button> -->
                            <!-- <div class="row">
                              <div class="col-lg-8 col-md-8 col-sm-8"></div>
                              <div class="col-lg-4 col-md-4 col-sm-4">
                                <b-button
                            class="btn btn-secondary p-6 m-1 pull-right"
                            
                            v-b-modal="
                            'modal-cancel-room-affter' +ind"
                            >ยกเลิก</b-button
                          >
                         
                              </div>
                             </div>
                             <div class="p-1"></div> -->
                            <!-- =========================================== Modal cancel room afternoon =================== -->
                            <!-- <b-modal
                            :id="'modal-cancel-room-affter'+ind"
                            size="sm"
                            footer-class="p-2"
                            header-class="p-2"
                            centered
                            class="modal-cancel-roomm"
                         
                          >
                            <h4 class="my-4">กรุณากด ยืนยัน เพื่อยกเลิกการจองห้อง </h4>
                            <template #modal-title>
                              <h5 class="m-1"> <b>ยกเลิกการจอง</b></h5>
                            </template>
              
                            <template #modal-footer="{ ok, cancel }">
                              <b-form
                              @submit.prevent="cancelRoom('ยกเลิกการจองห้อง-บ่าย'+ind)"
                            >
                            <b-button
                            size=""
                            class="b-between block"
                            variant="success"
                            data-dismiss="modal"
                            type="submit"
                            @click="ok()"
                          >
                            ยืนยัน
                          </b-button>
              
                          <b-button
                            size=""
                            class="b-between"
                            variant="secondary"
                            @click="cancel()"
                          >
                            เอาไว้ก่`อน
                          </b-button>
                            </b-form>
                             
                            </template>
                          </b-modal> -->
                            <!-- ========================================== END ======================================= -->
                            <!-- =========================================== END ======================================= -->
                          </div>
                        </span>
                      </span>
                    </div>
                    <!-- END -->
                    <!-- ======================================= Borrowed Status ================================ -->
                    <div class="card-columns-two">
                      <span v-for="(borrowed, ind) in histories" :key="ind">
                        <span
                          v-if="
                            (borrowed.room_id === 1 ||
                              borrowed.room_id === 2 ||
                              borrowed.room_id === 3 ||
                              borrowed.room_id === 4 ||
                              borrowed.room_id === 5 ||
                              borrowed.room_id === 6 ||
                              borrowed.room_id === 7) &&
                            borrowed.time_begin === '13:00'
                          "
                        >
                          <div
                            class="card card-order-list card-margin calendar-border"
                            v-if="
                              choosedDay2.dateFormat.moment ===
                                borrowed.meeting_date.moment &&
                              borrowed.trans_status === 'borrowed' &&
                              borrowed.time_begin === '13:00'
                            "
                          >
                            <div
                              v-if="borrowed.trans_status === 'borrowed'"
                              class="card-header card-status-booking"
                            >
                              <b style="color: #05900c">{{
                                borrowed.trans_status
                              }}</b>
                            </div>

                            <div class="card-body text-left">
                              <span v-if="!readMore[borrowed.order_id]">
                                <b-row>
                                  <!-- Time -->
                                  <b-col cols="4">
                                    <span> Time </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    : &nbsp;
                                    <span>
                                      <b style="font-size: 20px">
                                        <b-badge
                                          variant="danger"
                                          class="t-0"
                                          style="background-color: #05900c"
                                        >
                                          {{ borrowed.time_begin }} -
                                          {{ borrowed.time_end }}</b-badge
                                        >
                                      </b></span
                                    >
                                  </b-col>
                                  <!-- Room Name -->
                                  <b-col cols="4">
                                    <span>Room </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span style="font-size: 15px">
                                      : &nbsp;{{ borrowed.room_name }}
                                    </span>
                                    <span
                                        v-if="!readMore[borrowed.order_id]"
                                        @click="showMore(borrowed.order_id)"
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >เพิ่มเติม</span
                                      >
                                  </b-col>
                                </b-row>
                                <hr />

                                <!-- <b-row>
                                  Locker
                                  <b-col cols="4">
                                    <span> Locker </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        borrowed.locker_number
                                      }}</b>
                                    </span>
                                  </b-col>
                                  password
                                  <b-col cols="4">
                                    <span>Password</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        borrowed.locker_passcode
                                      }}</b>
                                      <span
                                        v-if="!readMore[borrowed.order_id]"
                                        @click="showMore(borrowed.order_id)"
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >เพิ่มเติม</span
                                      >
                                    </span>
                                  </b-col>
                                </b-row> -->
                              </span>
                              <span v-if="readMore[borrowed.order_id]">
                                <b-row>
                                  <!-- Time -->
                                  <b-col cols="4">
                                    <span> Time </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    : &nbsp;
                                    <span style="color: red">
                                      <b style="font-size: 20px">
                                        <b-badge variant="danger" class="t-0">
                                          {{ borrowed.time_begin }} -
                                          {{ borrowed.time_end }}</b-badge
                                        >
                                      </b></span
                                    >
                                  </b-col>
                                  <!-- Room Name -->
                                  <b-col cols="4">
                                    <span>Room </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span style="font-size: 15px">
                                      : &nbsp;{{ borrowed.room_name }}
                                    </span>
                                  </b-col>
                                </b-row>
                                <hr />

                                <b-row>
                                  <!-- Locker -->
                                  <b-col cols="4">
                                    <span> Locker </span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        borrowed.locker_number
                                      }}</b>
                                    </span>
                                  </b-col>
                                  <!-- password -->
                                  <b-col cols="4">
                                    <span>Password</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        borrowed.locker_passcode
                                      }}</b>
                                    </span>
                                  </b-col>
                                </b-row>

                                <b-row>
                                  <b-col cols="4">
                                    <span>Name</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        borrowed.whois_std_name
                                      }}</b>
                                    </span>
                                  </b-col>

                                  <b-col cols="4">
                                    <span>Std Code</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        borrowed.whois_std_code
                                      }}</b>
                                    </span>
                                  </b-col>

                                  <b-col cols="4">
                                    <span>Date</span>
                                  </b-col>
                                  <b-col cols="8" class="room-name">
                                    <span>
                                      : &nbsp;<b>{{
                                        borrowed.meeting_date | moment
                                      }}</b>
                                      <span
                                        v-if="readMore[borrowed.order_id]"
                                        @click="showLess(borrowed.order_id)"
                                        style="
                                          color: red;
                                          font-size: 15px;
                                          margin-left: 20px;
                                        "
                                        >ย่อ</span
                                      >
                                    </span>
                                  </b-col>
                                </b-row>
                              </span>
                            </div>
                          </div>
                        </span>
                      </span>
                    </div>
                    <!-- END -->
                    <!-- =========================================== Return ============================= -->
                    <div class="card-columns-two">
                      <span v-for="(returned, ind) in histories" :key="ind">
                        <span
                          v-if="
                            (returned.room_id === 1 ||
                              returned.room_id === 2 ||
                              returned.room_id === 3 ||
                              returned.room_id === 4 ||
                              returned.room_id === 5 ||
                              returned.room_id === 6 ||
                              returned.room_id === 7) &&
                            returned.time_begin === '13:00'
                          "
                        >
                          <div
                            class="card card-order-list card-margin calendar-border"
                            v-if="
                              choosedDay2.dateFormat.moment ===
                                returned.meeting_date.moment &&
                              returned.trans_status === 'returned' &&
                              returned.time_begin === '13:00'
                            "
                          >
                            <div
                              v-if="returned.trans_status === 'returned'"
                              class="card-header card-status-booking"
                            >
                              <b style="color: #616161">{{
                                returned.trans_status
                              }}</b>
                            </div>

                            <div class="card-body text-left">
                              <b-row>
                                <b-col cols="5">
                                  <span> Room name </span>
                                </b-col>
                                <b-col cols="7" class="room-name">
                                  <span style="color: #616161">
                                    : &nbsp;<b>{{ returned.room_name }}</b>
                                  </span>
                                </b-col>
                                <b-col cols="5">
                                  <span> Name </span>
                                </b-col>
                                <b-col cols="7" class="room-name">
                                  <span>
                                    : &nbsp; {{ returned.whois_std_name }}
                                  </span>
                                </b-col>
                                <b-col cols="5">
                                  <span> Student code </span>
                                </b-col>
                                <b-col cols="7" class="room-name">
                                  <span>
                                    : &nbsp;{{ returned.whois_std_code }}
                                  </span>
                                </b-col>
                              </b-row>
                            </div>
                          </div>
                        </span>
                      </span>
                    </div>
                    <!-- END -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col"></div>
      </div>
    </div>
  </div>
</template>

<script>
import navbarStaff from "../layouts/navbar_staff.vue";
import axios from "axios";
import $ from "jquery";
import VueHorizontalCalendar from "vue-horizontal-calendar";
import "@fullcalendar/core/vdom";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import FullCalendar from "@fullcalendar/vue";


export default {
  name: "meetingRoom",
  components: { navbarStaff, VueHorizontalCalendar, FullCalendar },
  data() {
    // const month = new Date().getMonth();
    // const year = new Date().getFullYear();
    return {
   
      text: "",
      radio_btn: "",
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        dateClick: this.handleDateClick,
        events: [
          {},
          // title: 'event 2', date: '2019-04-02'
        ],
      },
      attributes: [
        {
          key: "today",
          highlight: true,
          dates: new Date(),
        },
        {
          key: 1,
          customData: {
            title: "Lunch with mom.",
            class: "bg-red-600 text-white",
          },
          dates: new Date(),
        },
      ],
      ready: [],
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      readMore: {},
      isLoading: false,
      show: false,
      orderMore: {},
      s: [],
      newjobs: [],
      myjobs: [],
      packing: [],
      code: "",
      value: "",
      context: null,
      tokenjong: "NDMyMTNDNUYtRkZFNy00NjI1LUIwNTQtMkQ0QTkzOTIyQTM3",
      histories: [],
      dateTime: new Date(),
      choosedDay2: {
        dateFormat: "",
        year: "",
        month: "",
        date: "",
        day: "",
        timestamp: "",
      },
      thirty: "",
      status_room: [],
      list: [],
      calendar_his: [],
      confirmed: false,
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      showDismissibleAlertDanger: false,
      showDismissibleAlert_end: false,
      showDismissibleAlertDanger_end: false,
      showBorrowReturnSuccess: false,
      showBorrowReturnDanger: false,
      showStatusinlockerSuccess: false,
      showStatusinlockerDanger: false,
      message_return: "",
      statusalert: false,
      message_inlocker: "",
      message_end: "",
      message: "",
      items_table: [],
      fields: [
        { key: "index", label: "ลำดับ" },
        { key: "room_name", label: "Room", sortable: true },
        { key: "whois_std_name", label: "Name" },
        { key: "whois_std_code", label: "STD Code" },
        { key: "locker_number", label: "Locker" },
        { key: "locker_passcode", label: "Password" },
        { key: "time_begin", label: "Start" },
        { key: "time_end", label: "End" },
        { key: "meeting_date", label: "Date" },
        { key: "trans_status", label: "Status" },
      ],
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      check_time_moorning: true,
      check_status_studio_room: [],
      time_count: "",
    };
  },
  mounted() {
    // this.startCountdown();
    // let timmer = new Date();
    // this.thirty = timmer.getMinutes();
    if (localStorage.getItem("auth") != null) {
      this.user = false;
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.code = this.auth.std_code;
      // console.log(this.auth);
      if (this.auth.user_type === "Teacher" || this.auth.isLibraryStaff === 0) {
        this.isShowstaff;
      } else if (this.auth.user_type === "Student") {
        this.isShowstaff = true;
      }

      if (this.auth.isLibraryStaff === 1) {
        this.staff = true;
      } else {
        this.staff = false;
      }
    } else {
      this.user = true;
      this.isShowstaff = true;
    }



let nextTimeRenew = new Date().getTime() + 3600*1000 ;
var clear = setInterval(() => {
	let timeNow = new Date().getTime();
	var timeOut = nextTimeRenew - timeNow;
	var minute = Math.floor((timeOut % (1000 * 60 * 60)) / (1000 * 60));
	var second = Math.floor((timeOut % (1000 * 60)) / 1000);
	if (minute <= 0 && second <= 0) {
		clearInterval(clear);
	} else {

    this.time_count= `${minute}:${second<10 ?"0"+second:second}s`;
		// document.body.innerHTML = `0${minute}:${
		// 	second < 10 ? "0" + second : second
		// }s`;
	}
}, 1000);



 
    /*  play button */

    // eslint-disable-next-line no-unused-vars
    const playBtn = document.querySelector(".circle__btn");
    // console.log(playBtn);
    // eslint-disable-next-line no-unused-vars
    const wave1 = document.querySelector(".circle__back-1");
    // console.log(wave1);
    // eslint-disable-next-line no-unused-vars
    const wave2 = document.querySelector(".circle__back-2");
    // console.log(wave2);

    //
    window.setTimeout(function () {
      $(".alert")
        .fadeTo(500, 0)
        .slideUp(500, function () {
          $(this).remove();
        });
    }, 4000);
    //
    /*! Main */

    this.getready();

    // this.getHistoryAll();
    setInterval(() => {
      this.getHistoryAll();
    }, 15000);

    // eslint-disable-next-line no-unused-vars
    var timerID = setInterval(this.updateTime, 1000);
    // console.log(timerID);
    this.updateTime();
  },
  filters: {
    moment: function (date) {
      moment.locale("en");
      // return moment(date).add(543, "year").format("LL");
      return moment(date).format("LL");
    },
    formattime: function (date) {
      moment.locale("th");

      return moment(date).format("hh:mm");
    },
    thirtyminutes: function (date) {
      moment.locale("th");
      return moment(date).add(30, "minutes").format("hh:mm");
    },
  },
  methods: {
  
    onChange() {
      // console.log(this.radio_btn);
      this.getcalendar();
    },
    confirm_chk(test) {
      // eslint-disable-next-line no-unused-vars
      let a = test;
      // console.log("modal confirm", test);
    },
    showMore(id) {
      // console.log("show more", id);
      this.$set(this.readMore, id, true);
      // if(id){
      //   this.readMore= true;
      // }
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },

    showCalendarFuc() {
      this.showCalendar = true;
      this.getcalendar();
    },
    closeCalendar() {
      this.showCalendar = false;
    },
    getready() {
      let data = {
        token: this.token,
        staff_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/get_ready", data, {
          headers,
        })
        .then((res) => {
          this.ready = res.data.Orders;
          this.s = this.ready.length;
          this.packing = res.data.dasboard[0].packing;
          this.newjobs = res.data.dasboard[0].neworders;
          this.myjobs = res.data.dasboard[0].myjob;
          this.$isLoading(false);
        });
    },
    dateChange2(day) {
      // console.log(day, "check date day");
      this.list = [];
      if (localStorage.getItem("auth") != null) {
        this.user = false;
        this.auth = JSON.parse(localStorage.getItem("auth"));
        this.code = this.auth.std_code;
        // console.log(this.auth);
        if (this.auth.user_type === "Teacher") {
          this.isShowstaff;
          // console.log("Teacher");
        } else if (
          this.auth.user_type === "Student" ||
          this.auth.isLibraryStaff != 0
        ) {
          this.isShowstaff = true;
          // console.log("Student");
        }

        if (this.auth.isLibraryStaff === 1) {
          this.staff = true;
        } else {
          this.staff = false;
        }
      } else {
        this.user = true;
        this.isShowstaff = true;
        // console.log("anothor");
      }

      this.choosedDay2 = day;
      this.date = this.choosedDay2.dateFormat;
      let data = {
        select_date: this.choosedDay2.dateFormat,
      };
      // console.log("datetime ====", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/step1_getroom_status",
          data,
          { headers }
        )
        .then((res) => {
          // console.log(res);
          this.status_room = res.data.room_status;

          this.status_room.forEach((item) => {
            if (item.freetimes.length !== 0) {
              this.list.push(item);
            }
            // console.log("chk",item);
          });

          this.getHistoryAll();
        });
    },

    getHistoryAll() {
      // this.calendarOptions.events = [];
      let data = {
        select_date: this.choosedDay2.dateFormat,
      };
      this.check_status_studio_room = [];
      // console.log("get story data ==", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/get_history_all", data, {
          headers,
        })
        .then((res) => {
          if (res.data.msg.status === 200) {
            this.histories = res.data.histories;
            this.items_table = res.data.histories;

            this.histories.forEach((item) => {
              if (
                item.room_id === 8 ||
                item.room_id === 9 ||
                item.room_id === 10
              ) {
                this.check_status_studio_room.push(item);
              }

              // console.log(item.room_id);
            });
            // console.log("chk === ",this.histories[0].meeting_datemoment('hh:mm'));
            // this.calendar_his = res.data.motnly_histories;
          } else {
            alert(res.data.msg.message);
          }

          // console.log("History", this.histories);
          if (this.histories.length === 0) {
            this.status_show = false;
          } else {
            // console.log("true");
            this.status_show = true;
          }
        });
    },
    getcalendar() {
      // console.log("Get calendar");
      this.calendarOptions.events = [];
      let data = {
        select_date: this.choosedDay2.dateFormat,
      };
      // console.log("get story data ==", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/get_history_all", data, {
          headers,
        })
        .then((res) => {
          // console.log(this.calendar_his);
          if (res.data.msg.status === 200) {
            // this.histories = res.data.histories;
            this.calendar_his = res.data.motnly_histories;
            this.calendar_his.forEach((item) => {
              this.calendarOptions.events.push({
                title: item.room_name,
                date: item.meeting_date.slice(0, 10),
              });
            });
          } else {
            alert(res.data.msg.message);
          }

          // console.log("History", this.histories);
          if (this.histories.length === 0) {
            this.status_show = false;
          } else {
            // console.log("true");
            this.status_show = true;
          }
        });
    },

    checkSTD(event) {
      // console.log("Enter key ===", event.keyCode);
      // if (event.key === "Meta" || event.key === "Control") {
      //   console.log();
      // } else {
      // console.log("Enter key ===", event.key);
      console.log("enter");
      if (event.keyCode === 13) {
        let data = {
          std_code: this.text,
        };

        const token = this.tokenjong;
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        axios
          .post(
            "https://smartlibrary.ubru.ac.th/api/step4_borrow_return",
            data,
            {
              headers,
            }
          )
          .then((res) => {
            if (res.data.msg.status === 200) {
              this.message_return = res.data.msg.message;
              this.showBorrowReturnSuccess = true;
              this.histories = res.data.histories;
              this.text = "";
            } else {
              this.showBorrowReturnDanger = true;
              this.message_return = res.data.msg.message;
              this.text = "";
            }
          });
      } else {
        // console.log("event key code !=== 13");
      }

      // ยืนยันการเข้าใช้งานห้อง และ คืนห้อง
    },
    approve(order_token) {
      let data = {
        order_token: order_token,
        staff_code: this.code,
      };
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/room/approve ", data, {
          headers,
        })
        .then((res) => {
          if (res.data.msg.status !== 200) {
            // console.log("500");
            this.message = res.data.msg.message;
            this.showDismissibleAlertDanger = true;
            this.$isLoading(false);
          } else {
            // console.log("200");
            this.histories = res.data.histories;
            this.message = res.data.msg.message;
            if (res.data.histories.trans_status === "completed") {
              this.statusalert = true;
            }
            this.showDismissibleAlert = true;
            this.$isLoading(false);
          }
        });
    },
    ok() {
      // console.log("ok");
    },
    end(order_token) {
      // console.log(order_token);
      this.$bvModal.hide(order_token);
      let data = {
        order_token: order_token,
        staff_code: this.code,
      };
      // console.log(data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/room/end_of_usage", data, {
          headers,
        })
        .then((res) => {
          // console.log("end == ", res);
          if (res.data.msg.status !== 200) {
            // console.log("500");
            this.message_end = res.data.msg.message;
            this.showDismissibleAlertDanger_end = true;
            this.$isLoading(false);
            // this.$bvModal.hide(order_token);
          } else {
            // console.log("200");
            this.histories = res.data.histories;
            this.message_end = res.data.msg.message;
            if (res.data.histories.trans_status === "completed") {
              this.statusalert = true;
            }
            this.showDismissibleAlert_end = true;
            this.$isLoading(false);
          }
        });
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    inlocker(order_id) {
      let data = {
        order_id: order_id,
        staff_code: this.code,
      };
      // console.log(data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/room/inlocker", data, {
          headers,
        })
        .then((res) => {
          // console.log("inlocker == ", res);
          if (res.data.msg.status !== 200) {
            // console.log("500");
            this.message_inlocker = res.data.msg.message;
            this.showStatusinlockerDanger = true;
            this.$isLoading(false);
          } else {
            // console.log("200");
            this.histories = res.data.histories;
            this.message_inlocker = res.data.msg.message;
            if (res.data.histories.trans_status === "completed") {
              this.statusalert = true;
            }
            this.showStatusinlockerSuccess = true;
            this.$isLoading(false);
          }
        });
    },
    updateTime() {
      var cd = new Date();

      // datetime.getMinutes()+30
      this.time =
        this.zeroPadding(cd.getHours(), 2) +
        ":" +
        this.zeroPadding(cd.getMinutes(), 2);
      // ":" +
      // this.zeroPadding(cd.getSeconds(), 2);
      this.date =
        this.zeroPadding(cd.getFullYear(), 4) +
        "-" +
        this.zeroPadding(cd.getMonth() + 1, 2) +
        "-" +
        this.zeroPadding(cd.getDate(), 2) +
        " " +
        this.week[cd.getDay()];
    },
    zeroPadding(num, digit) {
      var zero = "";
      for (var i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
    handleSubmit() {
      // console.log("test modal");
      // Exit when the form isn't valid
      // if (!this.checkFormValidity()) {
      //   return
      // }
      // // Push the name to submitted names
      // this.submittedNames.push(this.name)
      // // Hide the modal manually
      // this.$nextTick(() => {
      //   this.$bvModal.hide('modal-prevent-closing')
      // })
    },
    cancelRoom(val) {
      console.log(val);
    },
    
  },
  computed: {
    minutes() {
      return String(Math.floor(this.time / 60)).padStart(2, "0");
    },
    seconds() {
      return String(this.time % 60).padStart(2, "0");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@100;200&display=swap");
.meetingroom {
  background: var(--greyLight-1) no-repeat center center;
  background-size: cover;
  min-height: 100vh;
  position: absolute;
  width: 100%;
}
.modal-content h5,
h4,
.btn {
  font-family: "Kanit", sans-serif !important;
}
.space {
  height: 100px;
}
.space_avatar {
  height: 60px;
}
.clash-card__unit-stats .alarm-inlocker:hover {
  background-color: #d153e8;
  border-bottom-left-radius: 14px;
}
.clash-card__unit-stats .cancel-inlocker:hover {
  /*#fb9b6f #ea8056*/
  background-color: #d153e8;
  border-bottom-right-radius: 14px;
}
.clash-card__unit-stats {
  color: white;
  font-weight: 700;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;

  .one-third {
    width: 50%;
    float: left;
    padding: 5px 2.5px;
  }

  sup {
    position: absolute;
    bottom: 4px;
    font-size: 45%;
    margin-left: 2px;
  }

  .stat {
    position: relative;
    font-size: 18px;
    margin-bottom: 10px;
  }

  .stat-value {
    text-transform: uppercase;
    font-weight: 400;
    font-size: 12px;
  }
}
.clash-card__unit-stats .no-border {
  border-right: none;
}
.clash-card__unit-stats--barbarian {
  background: rgb(181, 5, 245);

  /*  var(--bade-orange) #d153e8#d37b89 rgb(181, 5, 245) #ea8056;*/
  .one-third {
    border-right: 1px solid #d153e8;
  }
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}

/*  Avatar BUTTON  */
.circle_content {
  position: relative;
}
.circle_img {
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.circle_floting {
  position: absolute;
  /* width: 46px;
  height: 40px;
  
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 12px; */
  bottom: -25px;
  left: -22px;
  font-size: 14px;
}
.circle {
  grid-column: 2/3;
  grid-row: 4/6;
  width: 9rem;
  height: 100%;
  justify-self: center;
  border-radius: 1rem;
  display: grid;
  grid-template-rows: 1fr;
  justify-items: center;
  align-items: center;
}
.circle__btn {
  grid-row: 1/2;
  grid-column: 1/2;
  width: 9rem;
  height: 6rem;
  display: flex;
  margin: 0.6rem;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 3.2rem;
  color: var(--primary);
  z-index: 300;
  background: var(--greyLight-1);
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  cursor: pointer;
  position: relative;
}
.circle__btn.shadow {
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
}
.circle__btn .play {
  position: absolute;
  opacity: 0;
  transition: all 0.2s linear;
}
.circle__btn .play.visibility {
  opacity: 1;
}
.circle__btn .pause {
  position: absolute;
  transition: all 0.2s linear;
}
.circle__btn .pause.visibility {
  opacity: 0;
}
.circle__back-1,
.circle__back-2 {
  grid-row: 1/2;
  grid-column: 1/2;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  filter: blur(1px);
  z-index: 100;
}
.circle__back-1 {
  box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
    -0.4rem -0.4rem 0.8rem var(--white);
  background: linear-gradient(
    to bottom right,
    var(--greyLight-3) 0%,
    var(--white) 100%
  );
  -webkit-animation: waves 4s linear infinite;
  animation: waves 4s linear infinite;
}
.circle__back-1.paused {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}
.circle__back-2 {
  box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
    -0.4rem -0.4rem 0.8rem var(--white);
  -webkit-animation: waves 4s linear 2s infinite;
  animation: waves 4s linear 2s infinite;
}
.circle__back-2.paused {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}

@-webkit-keyframes waves {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes waves {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
/*END */
/*  TEBS SEGMENTED-CONTROL */
.tebs_content {
  position: relative;
}
.tebs_floting {
  position: absolute;
  /* width: 46px;
  height: 40px;
  
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 12px; */
  bottom: -50px;
  right: 0px;
  font-size: 14px;
}
.segmented-control {
  grid-column: 3/4;
  grid-row: 1/2;
  width: 17.9rem;
  height: 3rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  position: relative;
}
.segmented-control input {
  display: none;
}
.segmented-control > input:checked + label {
  transition: all 0.5s ease;
  color: rgb(209, 95, 2);
}
.segmented-control__1,
.segmented-control__2,
.segmented-control__3 {
  width: 6rem;
  height: 3.6rem;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #ff5f2d;
  transition: all 0.5s ease;
  margin-top: 1.5rem;
}
.segmented-control__1:hover,
.segmented-control__2:hover,
.segmented-control__3:hover {
  color: rgb(209, 95, 2);
}
.segmented-control__color {
  position: absolute;
  height: 2.5rem;
  width: 5.5rem;
  margin-left: 0.3rem;
  border-radius: 0.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  pointer-events: none;
}

#tab-1:checked ~ .segmented-control__color {
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-2:checked ~ .segmented-control__color {
  transform: translateX(5.8rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-3:checked ~ .segmented-control__color {
  transform: translateX(11.8rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/*ENE tabs*/
.calendar-border {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--greyLight-1);
}
.shadow-date {
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}

.room-name {
  margin-left: 0px;
}
.card-header:first-child {
  /* border-radius: 0px; */
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.card-columns .card {
  border-radius: 20px;
}
.calendar-list .card {
  border-radius: 20px;
}

.btn-floating-approve {
  position: absolute;
  /* top: -0px; */
  right: 0px;
  /* top: -100px; */
  font-size: 16px;
  /* color: rgb(186, 86, 79); */
  font-weight: bold;
  margin-top: -30px;
}
.btn-floating-cancle {
  position: absolute;
  /* top: -0px; */
  /* right: 0px; */
  /* top: -100px; */
  font-size: 17px;
  /* color: rgb(186, 86, 79); */
  font-weight: bold;
  margin-top: 16px;
  margin-left: 0px;
}
.card-approve {
  position: relative;
}

.card .card_image {
  width: inherit;
  height: inherit;
  border-radius: 20px;
}

.card .card_image img {
  width: inherit;
  height: inherit;
  border-radius: 20px;
  object-fit: cover;
}

.card-content-more {
  position: relative;
  color: orangered;
}

.form-group button {
  margin-bottom: 20px;
}
#button {
  border-radius: 30px;
}
/* card booked Status*/
.card-status-booking {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
.b-between {
  margin-right: 5px !important;
  margin-bottom: 5px;
}

/* End */

/*  SEARCH  */
.search {
  grid-column: 3/4;
  grid-row: 2/3;
  position: relative;
  display: flex;
  align-items: center;
}
.search__input {
  width: 100%;
  height: 3.4rem;
  border: none;
  border-radius: 1rem;
  font-size: 1.4rem;
  padding-left: 3.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  background: none;
  font-family: inherit;
  color: var(--greyDark);
}
.search__input::-moz-placeholder {
  color: var(--greyLight-3);
}
.search__input:-ms-input-placeholder {
  color: var(--greyLight-3);
}
.search__input::placeholder {
  color: var(--greyLight-3);
}
.search__input:focus {
  outline: none;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
}
.search__input:focus + .search__icon {
  color: orangered;
}
.search__icon {
  height: 1.3rem;
  position: absolute;
  font-size: 1.5rem;
  padding: 0 1.5rem;
  display: flex;
  color: var(--greyDark);
  transition: 0.3s ease;
}
/* Morrning */
.text-capitalize {
  border: none;
  border-radius: 1rem;
  font-size: 1.4rem;
  padding-left: 3.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  background: none;
  font-family: inherit;
  color: rgb(0, 0, 0);
  font-weight: bold;
}
/**Canceled*/
.capitalize-canceled {
  border: none;
  border-radius: 1rem;
  font-size: 1rem;
  padding: 1rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  background: none;
  font-family: inherit;
  color: orangered;
  font-weight: bold;
}
.capitalize-canceled p {
  margin-bottom: 0rem;
}

/* END */
/* card */
@media (max-width: 900px) {
  .circle_floting {
    position: absolute;
    /* width: 46px;
    height: 40px;
    
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 12px; */
    bottom: 0px;
    left: -15px;
    font-size: 14px;
  }
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}
@media (min-height: 414px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}
@media (max-height: 500px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 1;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}
@media (min-width: 768px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 2;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 1;
  }

  .card-columns-right-item {
    column-count: 3;
  }
  .time-column {
    column-count: 1;
  }
  h6 {
    margin-top: 10px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 2;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 2;
  }
  .card-columns-right-item {
    column-count: 3;
  }
  .time-column {
    column-count: 1;
  }
  h6 {
    margin-top: 10px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 2;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 3;
  }
  .card-columns-right-item {
    column-count: 3;
  }
  .time-column {
    column-count: 1;
  }
  h6 {
    margin-top: 10px;
  }
}
.no-footer-border {
  border-top: none !important; /* Remove the footer border */
}
.v-card-actions {
  border-top: none !important;
}
</style>
